import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../hooks/snackBar";
import PerfilSellerListProdutoSeller from "./ListProduto";
import { saveAs } from "file-saver";
import {
  gerarExelProdutosSeller,
  atualizarProdutos,
  statusReprocessamentoBase,
  listarProdutosComSemFiltro,
  gerarExelProdutosPost,
} from "../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";
import services from "../../../services";

import "./styles.scss";
import { empresasSellerTodos } from "../../../services/http/sellerService";
import { Autocomplete, MenuItem } from "@mui/material";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import { InputLabel, Select } from "@material-ui/core";
import InputSearch from "../../../components/InputSearch";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

const PerfilSellerCategoriaProduto = () => {
  const history = useHistory();
  const { idSeller } = services.storage.getUser();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [dadosEncontradosPorGtin, setBuscaPorGtin] = useState(null);
  const [reprocBase, setReprocBase] = useState(null);
  const [camposNulosIntegracaoSimplus, setCamposNulosIntegracaoSimplus] =
    useState(null);
  const [produtos, setProdutos] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });
  const [empresas, setEmpresas] = useState([]);
  const [produtoSeller, setProdutoSeller] = useState({ sellerId: "" });
  const [filtros, setFiltros] = useState({
    sellerId: "",
    status: "",
    cnpj: "",
  });

  const CarregarListaProdutos = (pagina) => {
    trackPromise(
      listarProdutosComSemFiltro(busca, pagina, filtros).then((res) => {
        if (res.data) {
          setProdutos(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar os produtos",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao tentar carregar os produtos",
        info: "error",
        open: true,
      });
    });
  };

  const CarregarListaProdutosComFiltro = (filtro, pagina) => {
    trackPromise(
      listarProdutosComSemFiltro(filtro, pagina, filtros).then((res) => {
        if (res.data) {
          setProdutos(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar os produtos",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao tentar carregar os produtos",
        info: "error",
        open: true,
      });
    });
  };

  const extrairBase = () => {
 

    // Converte string para boolean quando necessário
    let statusValue = null;
    if (filtros.status === "true") {
      statusValue = true;
    } else if (filtros.status === "false") {
      statusValue = false;
    }

    var obj = {
      filtro: busca || null,
      cnpj: filtros.cnpj || null,
      status: statusValue,
    };

  

    trackPromise(
      gerarExelProdutosSeller(obj).then((res) => {
        if (res.data) {
          saveAs(res.data, "Produtos-Seller.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base com produtos",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao extrair a base com produtos",
        info: "error",
        open: true,
      });
    });
  };
  // Acompanha o reprocessamento de base geral: atualiza o progresso na tela e exibe o resumo ao concluir.
  const acompanharReprocessamentoBase = (inicioPoll) => {
    let tentativas = 0;
    const maxTentativas = 4000; // base grande é lenta (~horas); poll a cada 3s
    const tick = () => {
      tentativas++;
      statusReprocessamentoBase()
        .then((r) => {
          const s = r?.data;
          const desteRun =
            s && s.inicio && Date.parse(s.inicio) >= inicioPoll - 5000;
          if (!desteRun) {
            if (tentativas < maxTentativas) setTimeout(tick, 3000);
            return;
          }
          if (s.emAndamento) {
            setReprocBase({ processados: s.processados, total: s.total });
            if (tentativas < maxTentativas) setTimeout(tick, 3000);
          } else if (s.fim) {
            setReprocBase(null);
            addSnackBar({
              message: `Base reprocessada: ${s.atualizados} atualizado(s), ${s.semSimplus} sem retorno na Simplus, ${s.erros} erro(s) — de ${s.total} pendente(s).`,
              info: "success",
              open: true,
            });
            CarregarListaProdutos(1);
          }
        })
        .catch(() => {
          if (tentativas < maxTentativas) setTimeout(tick, 3000);
        });
    };
    setTimeout(tick, 3000);
  };

  const reprocessarIntegracao = () => {
    const inicioPoll = Date.now();
    trackPromise(
      atualizarProdutos()
        .then((res) => {
          if (res.fail) {
            addSnackBar({
              message: "Erro ao iniciar o reprocessamento da base",
              info: "error",
              open: true,
            });
            return;
          }
          addSnackBar({
            message:
              "Reprocessamento da base iniciado. Acompanhando o progresso...",
            info: "info",
            open: true,
          });
          setReprocBase({ processados: 0, total: 0 });
          acompanharReprocessamentoBase(inicioPoll);
        })
        .catch((error) => {
          addSnackBar({
            message: "Erro ao tentar processar a atualização",
            info: "error",
            open: true,
          });
        })
    );
  };

  const mudarPaginaFilialSeller = (page) => {
    busca != ""
      ? CarregarListaProdutosComFiltro(busca, page)
      : CarregarListaProdutos(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaProdutosComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      CarregarListaProdutos(1);
    }
  }, [busca]);

  useEffect(() => {
   

    // Sempre executa quando os filtros mudam, mesmo que estejam vazios
    const delayDebounceFn = setTimeout(() => {
      CarregarListaProdutosComFiltro(busca || "", 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [filtros]);

  const CarregarListaSellers = (id) => {
    trackPromise(
      empresasSellerTodos().then((res) => {
        if (res.data) {
          setEmpresas(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar sellers",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao tentar carregar sellers",
        info: "error",
        open: true,
      });
    });
  };

  useEffect(() => {
    CarregarListaProdutos(1);
    CarregarListaSellers();
    // Retoma o acompanhamento se já houver um reprocessamento de base em andamento (sobrevive a reabrir a página).
    statusReprocessamentoBase()
      .then((r) => {
        const s = r?.data;
        if (s && s.emAndamento && s.inicio) {
          setReprocBase({ processados: s.processados, total: s.total });
          acompanharReprocessamentoBase(Date.parse(s.inicio) - 1000);
        }
      })
      .catch(() => {});
  }, []);

  const changesSeller = (value, propertie) => {
    setProdutoSeller((produto) => ({
      ...produto,
      [propertie]: value,
    }));
  };

  useEffect(() => {
    // Encontra a empresa selecionada para pegar o CNPJ
    const empresaSelecionada = empresas.find(
      (empresa) => empresa.id === produtoSeller.sellerId
    );

    setFiltros((prev) => ({
      ...prev,
      sellerId: produtoSeller.sellerId,
      cnpj: produtoSeller.sellerId
        ? empresaSelecionada?.dadosCadastrais?.cnpj || ""
        : "",
    }));
  }, [produtoSeller, empresas]);

  return (
    <div className="produtos-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Produtos</h2>
        </div>
      </div>

      {/* Botões de ação */}
      <div className="row mb-3">
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="button-anexar buton-green w-100"
            onClick={() => history.push("/produto/cadastro")}
          >
            CADASTRAR PRODUTO
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="button-anexar buton-green w-100"
            onClick={() => reprocessarIntegracao()}
          >
            PROC. INTEGRAÇÃO
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={() => history.push("/produto/importacao")}
          >
            IMPORTAR BASE
          </button>
        </div>
      </div>

      {reprocBase && (
        <div className="row mb-3">
          <div className="col-12">
            <div className="alert alert-info mb-0" role="status">
              Reprocessando base na Simplus: {reprocBase.processados} de{" "}
              {reprocBase.total} produto(s)... O resultado será exibido ao
              concluir.
            </div>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="row mb-3">
        <div className="col-sm-6 col-md-3">
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Seller"
            value={
              empresas.find((s) => s.id === produtoSeller?.sellerId)
                ? `${
                    empresas.find((s) => s.id === produtoSeller?.sellerId)
                      ?.dadosCadastrais?.cnpj
                  } - ${
                    empresas.find((s) => s.id === produtoSeller?.sellerId)
                      ?.dadosCadastrais?.nomeFantasia
                  }`
                : ""
            }
            onChange={(e) => {
              if (e.target.value === "") {
                // Se selecionou "Selecione um Seller", limpa os filtros
                setProdutoSeller({ sellerId: "" });
                setFiltros((prev) => ({
                  ...prev,
                  sellerId: "",
                  cnpj: "",
                }));
              } else {
                const selectedSeller = empresas.find(
                  (s) =>
                    `${s.dadosCadastrais?.cnpj} - ${s.dadosCadastrais?.nomeFantasia}` ===
                    e.target.value
                );
                if (selectedSeller) {
                  changesSeller(selectedSeller.id, "sellerId");
                }
              }
            }}
            select
            SelectProps={{
              MenuProps: MenuProps,
            }}
          >
            <MenuItem value="">
              <em>Selecione um Seller</em>
            </MenuItem>
            {empresas.map((empresa) => (
              <MenuItem
                key={empresa.id}
                value={`${empresa.dadosCadastrais?.cnpj} - ${empresa.dadosCadastrais?.nomeFantasia}`}
              >
                {`${empresa.dadosCadastrais?.cnpj} - ${empresa.dadosCadastrais?.nomeFantasia}`}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="col-sm-6 col-md-3">
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Status"
            value={filtros.status}
            onChange={(e) => {
              setFiltros((prev) => ({
                ...prev,
                status: e.target.value,
              }));
            }}
            select
            SelectProps={{
              MenuProps: MenuProps,
            }}
          >
            <MenuItem value="">
              <em>Selecione</em>
            </MenuItem>
            <MenuItem value="false">Incompleto</MenuItem>
            <MenuItem value="true">Completo</MenuItem>
          </TextField>
        </div>

        <div className="col-sm-6 col-md-6">
          <InputSearch buscar={buscar} buscaPor={busca} />
        </div>
      </div>

      {/* Lista de produtos */}
      <div className="row">
        <div className="col-12">
          <PerfilSellerListProdutoSeller
            response={produtos}
            mudarPagina={mudarPaginaFilialSeller}
            buscar={buscar}
            busca={busca}
          />
        </div>
      </div>
    </div>
  );
};

export default PerfilSellerCategoriaProduto;
